module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"change_email_address_for":"Change email address for sign in","current_email_address":"Current Email address","new_email_address":"New Email Address","enter_new_email_address":"Enter New Email Address"},"id":{"change_email_address_for":"tukar email untuk Log in","current_email_address":"email sekarang","new_email_address":"email baru","enter_new_email_address":"Isi email baru"}}')
  delete Component.options._Ctor
}
